// extracted by mini-css-extract-plugin
export default {"wrapper":"Date_wrapper__AAlmG"};